import AccessEditor from '@app/components/AccessEditor'
import CompanySelector from '@app/components/CompanySelector'
import EditPageContainer from '@app/components/EditPageContainer'
import { IEntityAllow } from '@app/models/EntityAllow'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { List } from 'immutable'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Input } from 'reactstrap'
import { actionCreators, IUserEditState } from '../modules/guestEdit'

interface IComponentRouterProps {
  id: string
}

type IComponentProps = IUserEditState &
  ICurrentUserState &
  RouteComponentProps<IComponentRouterProps> &
  typeof actionCreators

export default class GuestEditPage extends React.PureComponent<
  IComponentProps
> {
  public userId: string

  constructor(props: IComponentProps) {
    super(props)

    bindFunctions(this)
  }

  public componentDidMount() {
    const { id } = this.props.match.params

    this.userId = id

    this.props.loadUser(id)
  }

  public componentWillUnmount() {
    this.props.resetState()
  }

  public render() {
    if (!this.props.user || !this.userId) {
      return <div />
    }

    return (
      <EditPageContainer
        saveDisabled={false}
        title={`${this.props.user.fullName}`}
        onSaveClick={this._saveUser}
        onCancelClick={this._cancel}
      >
        <div className='container my-2'>
          {this._renderBasicInfo()}
          <h5 className='section-title mr-2'>Access</h5>
          {this._renderAccess()}
        </div>
      </EditPageContainer>
    )
  }

  private _saveUser() {
    this.props.save(this.userId)
  }

  private _cancel() {
    this.props.history.goBack()
  }

  private _renderAccess() {
    return (
      <div>
        <AccessEditor
          onChange={this.props.changeAccess}
          value={
            this.props.user.user
              ? this.props.user.user.allowedAccessTo
              : List<IEntityAllow>()
          }
        />
      </div>
    )
  }

  private _renderBasicInfo() {
    return (
      <div>
        <div className={`d-flex flex-row`}>
          <div className='mr-2 flex-grow-1'>
            <Input
              placeholder='First'
              value={this.props.user.firstName}
              name='FirstName'
              required
              onChange={(e) => this.props.setFirstName(e.target.value)}
            />

            <Input
              className='mt-2'
              placeholder='Title'
              value={this.props.user.title}
              onChange={(e) => this.props.setTitle(e.target.value)}
            />

            <Input
              className='custom-select mt-2'
              type='select'
              placeholder='Status'
              value={
                this.props.user.user ? this.props.user.user.status : 'Active'
              }
              onChange={(e) => this.props.setStatus(e.target.value)}
            >
              <option value='Active'>Active</option>
              <option value='Suspended'>Suspended</option>
            </Input>
          </div>
          <div className='flex-grow-1'>
            <Input
              placeholder='Last'
              className='mb-2'
              value={this.props.user.lastName}
              name='LastName'
              required
              onChange={(e) => this.props.setLastName(e.target.value)}
            />

            <CompanySelector
              onChange={this.props.setCompany}
              placeholder='Company'
              value={this.props.user.company}
            />
          </div>
        </div>
      </div>
    )
  }
}
